import { Event } from './event';

export class ReviewSubmittedEvent extends Event<void> {}
